module.exports = __webpack_public_path__ + "img/flndex01.095b011f.jpg";